export default __webpack_public_path__ + "static/media/arrow.03bbcfa5.svg";